import Content from "uxp-documentation/src/pages/uxp-api/reference-spectrum/Spectrum to SWC Mapping/index.md";
import * as React from 'react';
export default {
  Content,
  React
};